<template>
    <el-row class="bottom20">
        <el-row class="column-name" justify="start">
            <span @click="visible = !visible">
                <i class="el-icon-caret-right" v-show="!visible">
                </i>
                <i class="el-icon-caret-bottom" v-show="visible">
                </i>
                公司（{{page.total}}）
            </span>
        </el-row>
        <el-row v-show="visible">
            <company-children-list ref="list" :search="search" @after-query="handleAfterQuery">

            </company-children-list>
        </el-row>
    </el-row>
</template>

<script>
    import CompanyChildrenList from "@/views/organization/company/company.children.list";
    export default {
        name: "company.children.list.panel",
        components: { CompanyChildrenList },
        props: {
            search: {},
        },
        data() {
            return {
                visible: false,
                page: {
                    total: 0,
                    records: [],
                }
            };
        },
        methods: {
            handleAfterQuery(page) {
                this.page = page;
            }
        },
    }
</script>

<style scoped>

</style>